import { useEffect } from 'react';

import type { IAutofillSync } from '../types';

const AutofillSync = ({
  formik,
  fields = ['password1'],
}: IAutofillSync) => {
  useEffect(() => {
    fields.forEach((field) => {
      const fieldValue = (document.getElementById('portal')?.querySelector(`input[name="${field}"]`) as HTMLInputElement)?.value;
      if (fieldValue) {
        if (formik.values[field] !== fieldValue) {
          formik.setFieldValue(field, fieldValue, true);
        }
      }
    });
  }, []);

  return null;
};

export default AutofillSync;
